// src/layouts/DocsLayout.tsx — Documentation pages (sidebar + content)
import { Outlet } from "react-router-dom";
import DocsShell from "@/components/docs/DocsShell";
import { LanguageProvider } from "@/components/docs/LanguageContext";
import DocsMDXProvider from "@/components/docs/MDXProvider";

export default function DocsLayout() {
  return (
    <LanguageProvider>
      <DocsMDXProvider>
        <DocsShell>
          <Outlet />
        </DocsShell>
      </DocsMDXProvider>
    </LanguageProvider>
  );
}
